import { LocalDate } from '@js-joda/core';

import { FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, DatePicker, StyledMaxWidth } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys, patientTranslationKeys } from '../../translations';

type SubmissionDateFieldProps = FieldControllerProps<'submissionDate', LocalDate | null> & ClassNameProp;

export const SubmissionDateField = (props: SubmissionDateFieldProps): JSX.Element => {
   const controller = props.register(props.name, { required: true });

   return (
      <StyledMaxWidth maxWidth={172}>
         <DatePicker
            testId={props.name}
            controller={controller}
            label={entitlementStatementsTranslationKeys.createModal.submissionDate}
            placeholder={patientTranslationKeys.datePlaceholder}
            withNavigationArrows
            dayValidators={'dayAfterToday'}
         />
      </StyledMaxWidth>
   );
};
